module.exports = __webpack_public_path__ + "assets/img/mainItem03.d9233c82.png";